<template>
  <div v-if="errorMessages.length" style="width: 100%">
    <p
      class="form_field--errors"
      v-for="error in errorMessages"
      :key="error"
    >{{error}}</p>
  </div>
</template>

<script>
export default {
  name: "FormValidationErrors",
  props: {
    validationErrors: {
      type: [String, Array, undefined],
    },
  },
  computed: {
    errorMessages() {
      if (!this.validationErrors) {
        return [];
      }

      if (typeof (this.validationErrors) === 'string') {
        return [this.validationErrors];
      }

      return this.validationErrors;
    },
  },
}
</script>

<style lang="scss" scoped>
// Due to how Buefy works these styles must be in global styles

.form_field--errors {
  margin-top: 6px;
}
</style>
